// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bx61s1kHS9X4pV {
  min-width: 32px;
  min-height: 32px;
  margin-right: 8px;
  padding: 6px;
  transition-duration: unset;
}
.bx61s1kHS9X4pV.dfzJI_PuP5CEVA {
  margin-left: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.bx61s1kHS9X4pV.dfzJI_PuP5CEVA.XS2jDSQUvbhiwk {
  padding: 6px 0 6px 6px;
}
@media only screen and (max-width: 900px) {
  .bx61s1kHS9X4pV .zYtAt6pns4cM3s {
    margin-right: 0;
  }
}
@media only screen and (max-width: 900px) {
  .bx61s1kHS9X4pV .PqTwU_wwUxQy6s {
    display: none;
  }
}
.bx61s1kHS9X4pV.XS2jDSQUvbhiwk {
  padding: 6px;
}
.bx61s1kHS9X4pV.XS2jDSQUvbhiwk .zYtAt6pns4cM3s {
  margin-right: 0;
}
.bx61s1kHS9X4pV.XS2jDSQUvbhiwk .PqTwU_wwUxQy6s {
  display: none;
}
.NiH9mJY3iVeTAl {
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
@keyframes R3FymDnMx4Bpcq {
  0% {
    opacity: 20%;
  }
  50% {
    opacity: 80%;
  }
  100% {
    opacity: 20%;
  }
}
.Ddmd9Odbwri9dF {
  display: block;
  margin-left: 8px;
  padding-right: 6px;
  padding-left: 4px;
  border-radius: 20px;
  background-color: var(--dynamic-button-highlighted-hovered, var(--ds-surface, #ffffff));
  color: var(--dynamic-button-highlighted-text, var(--ds-text, #172b4d));
}
@media only screen and (max-width: 900px) {
  .Ddmd9Odbwri9dF {
    margin-right: 0px;
  }
}
.Ddmd9Odbwri9dF.xamRtL52GXax7W {
  animation-name: R3FymDnMx4Bpcq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  color: transparent;
  -webkit-user-select: none;
          user-select: none;
}
.Ddmd9Odbwri9dF.XS2jDSQUvbhiwk {
  margin-right: 0px;
}
.Ddmd9Odbwri9dF::before {
  content: '';
  display: inline-flex;
  position: relative;
  top: 1px;
  width: 12px;
  height: 12px;
  margin-right: 6px;
  border-radius: 50%;
  background-color: var(--ds-icon-brand, #0c66e4);
}
.body-light-board-background .Ddmd9Odbwri9dF::before {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  background-color: #579dff;
}
.body-dark-board-background .Ddmd9Odbwri9dF::before {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  background-color: #0c66e4;
}
.rRs_e7MShvOFXM {
  min-width: 32px;
  min-height: 32px;
  margin: 0 4px 0 0;
  padding: 6px 8px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  /* stylelint-disable-next-line no-descending-specificity */
  /* stylelint-disable-next-line no-descending-specificity */
}
@media only screen and (max-width: 900px) {
  .rRs_e7MShvOFXM {
    min-width: 24px;
    padding: 6px 0px 6px 8px;
  }
}
@media only screen and (max-width: 900px) {
  .rRs_e7MShvOFXM .PqTwU_wwUxQy6s {
    display: none;
    padding-right: 6px;
  }
}
@media only screen and (min-width: 901px) {
  .rRs_e7MShvOFXM .zYtAt6pns4cM3s {
    display: none;
  }
}
.rRs_e7MShvOFXM.XS2jDSQUvbhiwk > .PqTwU_wwUxQy6s {
  display: none;
}
.rRs_e7MShvOFXM.XS2jDSQUvbhiwk > .zYtAt6pns4cM3s {
  display: block;
  margin-right: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterButton": `bx61s1kHS9X4pV`,
	"isFiltering": `dfzJI_PuP5CEVA`,
	"isCollapsed": `XS2jDSQUvbhiwk`,
	"buttonIcon": `zYtAt6pns4cM3s`,
	"buttonText": `PqTwU_wwUxQy6s`,
	"buttonGroup": `NiH9mJY3iVeTAl`,
	"filtersCount": `Ddmd9Odbwri9dF`,
	"isLoadingCards": `xamRtL52GXax7W`,
	"fadeFiltersCount": `R3FymDnMx4Bpcq`,
	"clearFiltersButton": `rRs_e7MShvOFXM`
};
export default ___CSS_LOADER_EXPORT___;
